import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/cn'

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-sm px-2 py-0.5 text-xs font-medium ring-1 ring-inset',
  {
    variants: {
      variant: {
        default: 'bg-muted text-fg ring-border',
        success: 'bg-status-success/10 text-status-success ring-status-success/30',
        pending: 'bg-status-pending/10 text-status-pending ring-status-pending/30',
        failed: 'bg-status-failed/10 text-status-failed ring-status-failed/30',
        cancelled: 'bg-status-cancelled/10 text-status-cancelled ring-status-cancelled/30',
        info: 'bg-status-info/10 text-status-info ring-status-info/30',
        critical: 'bg-priority-critical/10 text-priority-critical ring-priority-critical/30',
        high: 'bg-priority-high/10 text-priority-high ring-priority-high/30',
        medium: 'bg-priority-medium/10 text-priority-medium ring-priority-medium/30',
        low: 'bg-priority-low/10 text-priority-low ring-priority-low/30',
        // shadcn-style aliases used by the databus track. Mapped to
        // the closest semantic variant so callers can use either
        // vocabulary without divergence.
        secondary: 'bg-muted text-fg ring-border',
        destructive: 'bg-status-failed/10 text-status-failed ring-status-failed/30',
        outline: 'bg-transparent text-fg ring-border',
      },
    },
    defaultVariants: { variant: 'default' },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { badgeVariants }
